import { CircularProgress, TextField } from "@material-ui/core";
import React from "react";
import styles from "./item.module.css";
import IconButton from "@material-ui/core/IconButton";
import DeleteRoundedIcon from "@material-ui/icons/DeleteRounded";
import SelectSearch from "../../../utils/Selectsearch/SelectSearch";

const Item = (props) => {
  const [stockSummary, setStockSummary] = React.useState(
    props.values.stockSummary
  );
  console.log("Item Component");
  console.log(props);
  const [state, setState] = React.useState(props.values.availableQuantity);

  React.useEffect(() => {
    setState(props.values.availableQuantity);
  }, [props.values.availableQuantity]);
  React.useEffect(() => {
    setStockSummary(props.values.stockSummary);
  }, [props.values.stockSummary]);

  let caluculatedTax = 0;
  let caluculatedTotal = 0;

  React.useEffect(() => {
    if (props.type == "EDIT") props.onChange(props.values.item, "item");
  }, []);

  if (props.values.tax) {
    console.log("tax if");
    console.log(props.values.tax);
    caluculatedTax =
      (parseInt(props.values.tax.gst) / 100) *
      (props.values.price * props.values.quantity);
  } else {
    caluculatedTax = props.values.taxAmount;
  }
  if (props.values.totalAmount == 0 && props.values.tax) {
    // caluculatedTotal =
    //   props.values.price * props.values.quantity + caluculatedTax;
    caluculatedTotal = Math.floor(props.values.price*1.18);
    caluculatedTotal = caluculatedTotal*props.values.quantity;
    caluculatedTotal =
      caluculatedTotal - (caluculatedTotal / 100) * props.values.discount;
  } else caluculatedTotal = props.values.totalAmount;

  const loading = props.index === props.loading;
  const error =
    props.values.availableQuantity == "NO_DATA" && props.type != "EDIT";

  console.log("values1", props.values.availableQuantity);

  return (
    <div className={styles.container}>
      {props.values.status == "PROCESSED" && (
        <div className={styles.disabledContent}>
          <p>PROCESSED</p>
        </div>
      )}

      {loading ? (
        <div className={styles.loader}>
          <CircularProgress radius={20} />
        </div>
      ) : null}

      <p className={styles.text}># {props.index + 1}</p>

      <SelectSearch
        variant="outlined"
        className={styles.textField}
        label={`Product / Part ${props.index + 1}`}
        value={props.values.item}
        onChange={(value) => props.onChange(value, "item")}
        keyCode="name"
        options={props.dataList}
        subHeading={true}
        error={props.error && props.error.item}
        helperText={props.error && props.error.item}
        tooltip={true}
      />

      {/* {props.orderType == "sales" && (
        <TextField
          variant="outlined"
          type="number"
          className={styles.textFieldSmall}
          label="Quantity Available"
          value={state}
          disabled
          error={error ? "Not Available" : false}
          helperText={error ? "Not Available" : false}
          InputLabelProps={{
            shrink: true,
          }}
        />
      )} */}
      {props.orderType == "sales" && (
        <ul style={{ listStyle: "none" }}>
          <li style={{ fontSize: "13px" }}>
            Total Stock :{stockSummary ? stockSummary.warehouseStock : 0}
          </li>
          <li style={{ fontSize: "13px" }}>
            Booked Stock :{stockSummary ? stockSummary.bookedStock : 0}
          </li>
          <li style={{ fontSize: "13px" }}>
            Balance Stock:{stockSummary ? stockSummary.balanceStock : 0}
          </li>
        </ul>
      )}

      <TextField
        variant="outlined"
        type="number"
        className={styles.textFieldSmall}
        label="Product Quantity"
        value={props.values.quantity}
        onChange={(e) => {
          let val = e.target.value;
          console.log(val > 0 && val < props.values.oldQuantity);

          console.log(val > 0 && val <= state + props.values.oldQuantity);
          if (val < 0) {
            val = 0;
          }
          props.onChange(val, "quantity");
        //   if (props.type == "EDIT") {
        //     if (
        //       (val > 0 &&
        //         val <= state + props.values.oldQuantity &&
        //         state != "NO_DATA") ||
        //       props.orderType == "purchase" ||
        //       props.orderType ==
        //         "sales"(val > 0 && val <= props.values.oldQuantity)
        //     )
        //       props.onChange(val, "quantity");
        //   } else {
        //     if (
        //       (val > 0 && val <= state) ||
        //       props.orderType == "purchase" ||
        //       props.orderType == "sales"
        //     )
        //       props.onChange(val, "quantity");
        //   }
        }}
        // disabled={disable}
        error={props.error && props.error.quantity}
        helperText={props.error && props.error.quantity}
      />

      <TextField
        variant="outlined"
        type="number"
        className={styles.textFieldSmall}
        label="Product Price"
        // disabled={error}
        value={props.values.price}
        onChange={(e) => {
          props.onChange(e.target.value, "price");
        }}
        error={props.error && props.error.price}
        helperText={props.error && props.error.price}
      />

      <SelectSearch
        variant="outlined"
        className={styles.textFieldSmall}
        label={`Tax`}
        value={props.values.tax}
        onChange={(value) => props.onChange(value, "tax")}
        keyCode="name"
        options={props.taxList}
        subHeading={true}
        disabled={error}
        error={props.error && props.error.tax}
        helperText={props.error && props.error.tax}
      />
      {props.orderType == "sales" && (
        <TextField
          variant="outlined"
          type="number"
          className={styles.textFieldSmall}
          label="Discount"
          value={props.values.discount}
          onChange={(e) => props.onChange(e.target.value, "discount")}
        />
      )}

      <TextField
        variant="outlined"
        type="number"
        className={styles.textFieldSmall}
        label="Total Amount"
        // disabled={error}
        value={caluculatedTotal}
        onChange={(e) => props.onChange(e.target.value, "totalAmount")}
      />

      <IconButton onClick={props.onDelete}>
        <DeleteRoundedIcon />
      </IconButton>
    </div>
  );
};

export default Item;
